import * as components from './components'

export default [
  {
    path: '/event/create',
    component: components.EventCreate,
    name: 'eventCreate',
    props: true
  },
  {
    path: '/event/:uuid/home',
    component: components.EventDetail,
    name: 'eventDetail',
    props: true
  },
  {
    path: '/event/:uuid/edit',
    component: components.EditEvent,
    name: 'editEvent',
    props: true
  },
  {
    path: '/event/upload',
    component: components.EventUpload,
    name: 'eventUpload',
    props: true
  }
]



// WEBPACK FOOTER //
// ./src/app/event/routes.js